<!-- 由 suu 创建于 2022-01-19 星期三 -->
<template>
  <div class="recipe-feedback" v-if="questionList.length">
    <div class="title">使用反馈</div>
    <div class="desc">
      您的建议对我们来说非常重要，为了更好的为用户服务，帮助更多的用户完成自己的目标，我们将不断采集用户的使用建议，优化我们的服务。
    </div>
    <div class="quetion-list">
      <div v-for="(item, index) in questionList" :key="index">
        <v-radio
          v-if="item.field_type == 'radio'"
          :data="item"
          :index="index"
          @change="bindRadioChange"
        ></v-radio>
      </div>
    </div>
    <div class="other">其他建议</div>
    <div class="textarea-content">
      <van-field
        v-model="questionList[2].value"
        rows="2"
        autosize
        type="textarea"
        :maxlength="maxLength"
        placeholder=""
        show-word-limit
      />
    </div>
    <div
      class="btn"
      @click="submitConfirm"
      v-if="s_from !== '兑换码领取(转介)'"
    >
      <template v-if="s_from !== '兑换码领取(转介)'">
        <span>提交并领取50元优惠券</span>
        <div class="tips">50元优惠券</div>
      </template>
      <span v-else>提交</span>
    </div>
  </div>
</template>

<script>
import vRadio from './ponents/fback-radio.vue'
export default {
  name: 'recipe-feedback',

  components: { vRadio },

  props: {},

  data() {
    return {
      id: this.$route.query.id,
      maxLength: 200,
      textValue: '',
      showQrcode: false,
      questionList: [],
      s_from: this.$route.query.s_from
    }
  },

  computed: {},

  watch: {},

  created() {
    this.getFeedbackQuestion()
  },

  mounted() {},

  destroyed() {},

  methods: {
    getFeedbackQuestion() {
      this.$toast.loading('加载中...')
      this.$http
        .postApp('member/AppCamp/posterCoupleBack', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.questionList = res.data
          } else {
            this.$toast(res.msg)
          }
          this.$toast.clear()
        })
        .catch(() => {
          this.$toast.clear()
        })
    },
    bindRadioChange(e) {
      let value = e.value
      let index = e.index
      this.questionList[index].value = value
      console.log(this.questionList)
    },
    checkParams() {
      let res = true
      this.questionList.map((item) => {
        if (item.value === '') {
          res = false
        }
      })
      return res
    },
    submitConfirm() {
      if (!this.checkParams()) {
        this.$toast.fail('反馈未填写完成')
        return
      }
      this.$dialog
        .confirm({
          title: '提示',
          message: '确认提交反馈？'
        })
        .then(() => {
          // on confirm
          this.submit()
        })
        .catch(() => {
          // on cancel
        })
    },
    submit() {
      this.$toast.loading('提交中...')
      this.$http
        .postApp('member/AppCamp/posterCoupleBackSave', {
          info: this.questionList, // 小程序中数组直传  这里是否需要转化？
          rid: this.id
        })
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            sessionStorage.setItem(
              'feedbackData',
              JSON.stringify(this.questionList)
            )
            this.$router.push(`/recipe-feedbackStatus?s_from=${this.s_from}`)
          } else {
            this.$toast(res.msg)
          }
          this.$toast.clear()
        })
        .catch(() => {
          this.$toast.clear()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 750) * 100vw;
}
.recipe-feedback {
  min-height: 100vh;
  background-color: #f7f7f7;
  padding: vw(40);
  box-sizing: border-box;
  .title {
    text-align: center;
    font-weight: 600;
    font-size: vw(36);
    color: #000;
    margin-bottom: vw(28);
  }
  .desc {
    font-size: vw(24);
    line-height: vw(40);
    color: rgba(0, 0, 0, 0.5);
    margin-bottom: vw(40);
  }
  .other {
    font-size: vw(30);
    color: #000;
    margin-bottom: vw(22);
  }
  .textarea-content {
    position: relative;
    width: vw(670);
    margin-bottom: vw(56);
    box-sizing: border-box;
  }
  .limit {
    position: absolute;
    right: vw(20);
    bottom: vw(14);
    font-size: vw(28);
    color: rgba(56, 61, 72, 0.5);
  }
  .btn {
    position: relative;
    width: 100%;
    height: vw(72);
    font-size: vw(28);
    text-align: center;
    color: #fff;
    line-height: vw(72);
    background-image: linear-gradient(90deg, #3461e5 0%, #608bf7 100%);
    border-radius: vw(20);
    margin-bottom: vw(40);
  }
  .fixed-btn {
    font-size: vw(24);
    position: fixed;
    right: vw(0);
    bottom: vw(200);
    display: flex;
    padding: vw(10);
    box-sizing: border-box;
    align-items: center;
    text-align: center;
    color: #fff;
    width: vw(100);
    height: vw(100);
    overflow: hidden;
    border-radius: 50%;
    background-image: linear-gradient(90deg, #3461e5 0%, #608bf7 100%);
    z-index: 88;
  }
  .tips {
    position: absolute;
    right: vw(26);
    top: vw(0);
    padding: vw(0) vw(10);
    transform: translate(0%, -50%);
    height: vw(38);
    line-height: vw(38);
    background-color: #fa5a73;
    border-radius: vw(4);
  }
}
</style>
